import axios from 'axios'
import configs from '@/config'
import Cookies from 'js-cookie'
import Utils from '@/utils'
// 创建axios实例
const service = axios.create({
  baseURL: configs.baseUrl || '', 
  timeout: 20000 // 请求超时时间
})
// request拦截器
service.interceptors.request.use(config => {
  if (!config.params) {
    config.params = {}
  }
  config.autoCloseLoading = !config.params.noLoading
  if (!config.params.noLoading) {
    Utils.showLoading()
  }
  delete config.params.noLoading

  if (Cookies.get('access_token')) {
    config.headers.token = Cookies.get('access_token')
    config.headers.appId = configs.appId
  }
  
  if ((config.method + '').toLocaleLowerCase() == 'post') {
    config.data = config.params
    config.params = {}
  }
  return config
}, error => {
  Promise.reject(error)
})
// respone拦截器
service.interceptors.response.use(
  response => {
    if (response.config.autoCloseLoading) {
      Utils.hiddenLoading()
    }
    let getResData = response.config.getResData
    return returnData(response, getResData)
  },
  error => {
    if (error.config.autoCloseLoading) {
      Utils.hiddenLoading()
    }
    if (error.code === 'ECONNABORTED') {
      error.message = '服务器响应超时，请重试'
    }
    if (!window.navigator.onLine) {
      error.message = '网络异常，请检查网络设置'
    }
    if (error.response.status === 500) {
      error.message = error.response.data.error
    }
    return Promise.reject({
      status: 'ERROR',
      error: error.message
    })
  }
)

function returnData (response, isResponse) {
  return isResponse ? response : (response.data || {})
}

export default service
